<template>
  <div class="general-wrapper">
    <Header />
    <PageContainer>
      <StoreCard :mode="'hotels'"/>

      <div class="iqos-grid">
        <div class="iqos-column">
            <!-- <StickersBuyCard /> -->
        </div>
      </div>
      
      <div class="iqos-grid mt-24">
        <div class="iqos-column right-space">
          <SystemMotdPanel :mode="'hotels'" />
          <PaymentCard :mode="'hotels'" class="right-space" />
        </div>
        <div class="iqos-column">
          <CallServicesPanel />
          <!-- <DemoQRCodePanel :mode="'rooms'" /> -->
        </div>
      </div>
    </PageContainer>
  </div>
</template>

<script>
import HallsPanel from "@/components/inside/HallsPanel.vue";
import CallServicesPanel from "@/components/inside/CallServicesPanel.vue";
import GeolocationPanel from "@/components/inside/GeolocationPanel.vue";
import StickersBuyCard from "@/components/StickersBuyCard.vue";
import PaymentCard from "@/components/PaymentCard.vue";
import SelfServicePanel from "@/components/inside/SelfServicePanel.vue";
import ServingFeeMode from "@/components/general/ServingFeeMode.vue";
import SystemMotdPanel from "@/components/SystemMotdPanel.vue";
import StoreCard from "@/components/subscriptions/StoreCard.vue";

import DemoQRCodePanel from "@/components/DemoQRCodePanel.vue";

import RemoteScroller from "@/components/RemoteScroller.vue";

export default {
  data() {
    return {};
  },
  methods: {},
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
    hasSections() {
      if (this.isInsideLiteEnabled) return true;
      return !!this.cafe.sections && this.cafe.sections.length;
    },
    isInsideLiteEnabled() {
      return !!this.cafe.inside_lite;
    },
    isHotel() {
      return this.$store.getters.isHotel;
    },
  },
  components: {
    HallsPanel,
    SystemMotdPanel,
    CallServicesPanel,
    GeolocationPanel,
    StickersBuyCard,
    PaymentCard,
    RemoteScroller,
    SelfServicePanel,
    ServingFeeMode,
    DemoQRCodePanel,
    StoreCard
  },
};
</script>

<style scoped>
</style>